import { Icon } from "@fortawesome/fontawesome-svg-core";
import { faStarCircle } from "@fortawesome/pro-solid-svg-icons";
import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { excludePaths } from "~/constants/paths";
import Button from "~/spocketUI/components/Button";
import Modal from "~/spocketUI/components/Modal";
import { SVG } from "~/spocketUI/components/SVG";
import { Plans } from "../plans";

export const UpgradeButton = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState<boolean>(false);

  if (
    excludePaths.find((path) => new RegExp(path).test(window.location.pathname))
  )
    return null;

  return (
    <Fragment>
      <Button
        onClick={() => setShow(true)}
        bgColor="green"
        color="white"
        fontSize="16px"
        width="249px"
        radius={32}
        shadow="md"
        alignSelf="flex-end"
        title={t("settings.upgrade_button_title") as string}>
        <SVG icon={faStarCircle as Icon} size="xl" />
        {t("settings.upgrade_button")}
      </Button>
      <Modal isShowing={show} hide={() => setShow(!show)} minWidth="80%">
        <Plans closeModal={() => setShow(!show)} />
      </Modal>
    </Fragment>
  );
};
